import { render } from "./SelfAssessmentV2.vue?vue&type=template&id=02288d06&scoped=true"
import script from "./SelfAssessmentV2.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2.vue?vue&type=style&index=0&id=02288d06&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02288d06"]])

export default __exports__